<template>
  <Icon :component="EnlargeSvg" class="icon" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import EnlargeSvg from './svg/EnlargeSvg.vue';

export default defineComponent({
  name: 'EnlargeIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      EnlargeSvg: markRaw(EnlargeSvg)
    };
  }
});
</script>

<style lang="scss" scoped>
.icon {
  color: $primary-color;
  &:hover {
    color: $primary-hover-color;
  }
}
</style>
